import React from 'react';
import { companyInfo } from '../data/mock';
import { Mail, MapPin, Linkedin } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_0caad674-da07-42ae-8497-83c3015cb5cd/artifacts/d09l0qqk_AEE_logo_image.svg';

const Footer = () => {
  const quickLinks = [
    { name: 'About', href: '#hero' },
    { name: 'Services', href: '#services' },
    { name: 'Industries', href: '#industries' },
    { name: 'Projects', href: '#projects' },
    { name: 'Contact', href: '#contact' }
  ];

  const services = [
    'Modular Cleanrooms',
    'Design & Engineering',
    'Project Management',
    'Validation Services',
    'Maintenance & Support'
  ];

  return (
    <footer className="bg-gradient-to-b from-[#0F172A] to-[#0a0f1a] text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 left-1/3 w-80 h-80 bg-[#1C4B8A]/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-[#1C4B8A]/10 rounded-full blur-3xl" />
      </div>
      
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-16 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Company */}
          <div className="flex flex-col items-center text-center">
            <div className="p-4 rounded-2xl bg-white mb-5">
              <img src={LOGO_URL} alt="AEE Logo" className="h-16 w-auto" />
            </div>
            <p className="text-sm text-white/60 leading-relaxed mb-5">
              {companyInfo.tagline}
            </p>
            <a 
              href={companyInfo.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-white/10 backdrop-blur-sm border border-white/10 hover:bg-[#1C4B8A] hover:border-[#1C4B8A] transition-all"
            >
              <Linkedin className="w-4 h-4" />
            </a>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-bold text-white mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm text-white/60 hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-white mb-5">Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service} className="text-sm text-white/60">{service}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-white mb-5">Contact</h4>
            <div className="space-y-4 text-sm">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <MapPin className="w-4 h-4 text-[#8ABDE0]" />
                </div>
                <span className="text-white/60">{companyInfo.address}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
                  <Mail className="w-4 h-4 text-[#8ABDE0]" />
                </div>
                <a href={`mailto:${companyInfo.email}`} className="text-white/60 hover:text-white transition-colors">
                  {companyInfo.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/50">
            © {new Date().getFullYear()} Advanced Engineered Environments. All rights reserved.
          </p>
          <p className="text-sm text-white/50 px-4 py-1.5 rounded-full bg-white/5 border border-white/10">ISO 5-8 Cleanroom Solutions</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
